import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type { Errors } from './types';

// eslint-disable-next-line jira/export/no-external-exports
export { default as errors } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/errors/fixtures';

export const getErrors = (state: State): Errors => state.ui.Errors.errors;

export const getErrorLogDialogState = (state: State): boolean =>
	state.ui.Errors.isErrorLogDialogOpen;

export const getIsProjectLimitExceeded = (state: State): boolean =>
	state.ui.Errors.isProjectLimitExceeded;
